var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightanglearrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.67461 2.95388C5.88428 2.77417 6.19993 2.79845 6.37964 3.00811L10.3796 7.67478C10.5401 7.86202 10.5401 8.13832 10.3796 8.32557L6.37964 12.9922C6.19993 13.2019 5.88428 13.2262 5.67461 13.0465C5.46495 12.8668 5.44067 12.5511 5.62038 12.3414L9.34147 8.00017L5.62038 3.6589C5.44067 3.44924 5.46495 3.13359 5.67461 2.95388Z",
    fill: "#1C274C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightanglearrow);
export default __webpack_public_path__ + "static/media/rightanglearrow.3791978e02368249e4c73251e66387cf.svg";
export { ForwardRef as ReactComponent };